/* eslint-disable @typescript-eslint/no-explicit-any */
import { useMemo } from 'react';

import { useUserAgent } from '@src/contexts/user-agent-context/use-user-agent';

type PostMessageData = {
  type: string;
  [key: string]: unknown;
};

export const usePostMessageToReactNativeWebView = <T extends PostMessageData>() => {
  const postMessage = (data: T) => {
    console.log('postMessage', data);
    const enhancedWindow: typeof window & { ReactNativeWebView?: { postMessage: (data: string) => void } } = window;

    if (enhancedWindow?.ReactNativeWebView) {
      enhancedWindow.ReactNativeWebView?.postMessage(JSON.stringify(data));
    }
  };

  return { postMessage };
};

export const useAppViewCallback = <T extends PostMessageData>(postMessageData: T, nonAppCallback?: VoidFunction) => {
  const { isAppWebView } = useUserAgent();
  const { postMessage } = usePostMessageToReactNativeWebView();

  return useMemo(() => {
    if (!isAppWebView) {
      return nonAppCallback;
    }

    return () => {
      postMessage(postMessageData);
    };
  }, [isAppWebView, nonAppCallback, postMessage, postMessageData]);
};
